import { Link } from "react-router-dom";

export default function SiteIntroBanner() {
  return (
    <section className="overflow-hidden rounded-lg bg-primary-900">
      <div className="grid grid-cols-1 gap-6 p-6 md:grid-cols-2 md:items-center md:gap-10 md:p-10">
        <div className="flex flex-col gap-4">
          <span className="w-fit rounded-full bg-accent-500/90 px-3 py-1 text-xs text-background-50">
            关于我们
          </span>
          <h2 className="font-heading text-xl font-bold text-background-50 md:text-2xl">
            巨乳娱乐资讯网 — 把娱乐资讯讲清楚
          </h2>
          <p className="text-sm leading-relaxed text-background-100/80">
            我们专注于影视作品介绍、影视人物资料与网络热门话题的聚合整理。
            不是零散的信息堆砌，而是帮你把作品、人物与讨论串成一条清晰的线索，
            让每一次浏览都更有收获。
          </p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/about"
              className="whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-accent-600"
            >
              了解网站定位
            </Link>
            <a
              href="mailto:contact@juentertainment.example"
              className="whitespace-nowrap rounded-md border border-background-100/30 px-4 py-2 text-sm text-background-100 transition-colors hover:border-accent-400 hover:text-accent-400"
            >
              联系我们
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {[
            { icon: "ri-film-line", title: "影视作品", desc: "类型 / 地区 / 年份多维筛选" },
            { icon: "ri-user-star-line", title: "明星人物", desc: "资料与代表作品一览" },
            { icon: "ri-chat-3-line", title: "网络话题", desc: "热议讨论持续追踪" },
            { icon: "ri-links-line", title: "关联推荐", desc: "作品人物话题互相串联" },
          ].map((item) => (
            <div
              key={item.title}
              className="flex flex-col gap-2 rounded-lg bg-primary-950/60 p-4"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
              </span>
              <span className="text-sm font-medium text-background-50">
                {item.title}
              </span>
              <span className="text-xs text-background-100/70">{item.desc}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}